
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" :form="form" >
        <a-row :gutter="48">
          <a-col :md="4" :sm="8">
            <a-form-item>
              <a-input placeholder="诊断编号" @keyup.enter="handleSearch" v-decorator="[ 'number']"/>
            </a-form-item>
          </a-col>

          <a-col :md="4" :sm="8">
            <a-form-item>
              <select-hospital ref="hospital" @search_condition_changed="handleSearch" />
            </a-form-item>
          </a-col>

          <a-col :md="4" :sm="8">
            <a-form-item>
              <a-select v-decorator="['diagnose_status']" @change="handleSearch" placeholder="诊断状态">
                <a-select-option key="0">待诊断</a-select-option>
                <a-select-option key="1">已诊断</a-select-option>
                <a-select-option key="2">全部</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item>
              <select-time ref="time" @search_condition_changed="handleSearch" />
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleSearch">查询</a-button>
              <a-button style="margin-left: 20px" @click="handleAdd">添加</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <s-table
      size="default"
      :columns="columns"
      :data="loadData"
      @add_user_ok="reloadData()"
      ref="datatable"
      :showPagination=true
    >

      <span slot="action" slot-scope="text, record">
        <a-tag size="small" color="red" @click="handleDelete(record)">删除</a-tag>
      </span>
    </s-table>

  </a-card>
</template>

<script>
import STable from '@/components/table/'
import SelectHospital from '@/components/selector/SelectHospital'
import SelectTime from '@/components/selector/SelectTime'
import SelectLabelStatus from '@/components/selector/SelectLabelStatus'

// import { getRoleList, getServiceList, getUserList } from '@/api/manage'
import { axios } from '@/utils/request'
import { DatabaseOutline } from '@ant-design/icons/lib/dist'
import { getDiagnoseList, deleteDiagnose } from '@/api/diagnose'
import { getDiagnoseStatusText, getHospitalText } from '@/utils/const'

export default {
  name: 'DiagnoseList',
  components: {
    STable,
    SelectHospital,
    SelectTime,
    SelectLabelStatus
  },
  data () {
    return {
      description: '列表使用场景：后台管理中的权限管理以及角色管理，可用于基于 RBAC 设计的角色权限控制，颗粒度细到每一个操作类型。',
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this),
      mdl: {},

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '编号',
          dataIndex: 'diagnose_id',
          key: 'diagnose_id'
        },
        {
          title: '诊断编号',
          dataIndex: 'diagnose_uid',
          key: 'diagnose_uid'
        },
        {
          title: '数据来源',
          dataIndex: 'source_id',
          key: 'source_id'
        },
        {
          title: '患者姓名',
          dataIndex: 'case_name',
          key: 'case_name'
        },
        {
          title: '诊断状态',
          dataIndex: 'diagnose_status',
          key: 'diagnose_status'
        },
        {
          title: '上传时间',
          dataIndex: 'create_time',
          key: 'create_time'
        },

        {
          title: '操作',
          width: '150px',
          dataIndex: 'action',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      dataHandle: this.loadData,
      selectedRowKeys: [],
      selectedRows: []
    }
  },
  methods: {

    onChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },

    loadData (page) {
      const _this = this
      return new Promise(resolve => {
        return getDiagnoseList(Object.assign({
          item_id: this.$store.getters.projectId,
          page_num: page.pageNo,
          page_size: page.pageSize
        }, _this.conditions))
          .then(res => {
            if (res.data.length == 0) {
              _this.$refs.datatable.localLoading = false
              const params = {
                data: [],
                pageNo: 1,
                pageSize: 10,
                totalCount: 0
              }
              resolve(params)
              return
            }
            const datas = []

            for (let item = res.data.shift(); item != null; item = res.data.shift()) {
              datas.push({
                diagnose_id: item.diagnose_id,
                diagnose_uid: item.diagnose_uid,
                case_name: item.case_name,
                create_time: item.create_time,
                source_id: getHospitalText(item.source_id),
                diagnose_status: getDiagnoseStatusText(item.diagnose_status),
                originData: item
              })
            }
            const params = {
              data: datas,
              pageNo: page.pageNo,
              pageSize: page.pageSize,
              totalCount: res.count
            }
            resolve(params)
          }).catch(() => {
            this.$refs.datatable.localLoading = false
          })
      })
    },

    reloadData () {
      this.dataHandle = this.loadData
      this.$refs.datatable.refresh()
    },
    handleSearch () {
      const conditions = this.conditions = {}
      this.form.validateFields((err, values) => {
        if (values.number)conditions.data_id = values.number
        if (values.diagnose_status && values.diagnose_status != 2)conditions.diagnose_status = values.diagnose_status
      })
      //
      if (this.$refs.hospital.value)conditions.source_id = this.$refs.hospital.value
      //
      if (this.$refs.time.value.isNull == false) {
        conditions.create_time = this.$refs.time.value.from
        conditions.end_time = this.$refs.time.value.to
      }
      this.reloadData()
    },
    handleAdd () {
      this.$router.push({ name: 'adddiagnose' })
    },
    handleDelete (record) {
      const _this = this
      const diagnose_uid = record.diagnose_uid
      //
      _this.$confirm({
        title: '真的要删除诊断\'' + diagnose_uid + '\'吗？',
        content: '单击确定删除',
        onOk () {
          return new Promise((resolve, reject) => {
            deleteDiagnose(diagnose_uid).then(res => {
              _this.$message.success('删除成功')
              resolve()
            }).catch(() => {
              _this.$message.error('删除失败')
              reject()
            }).finally(() => {
              _this.reloadData()
            }
            )
          })
        },
        onCancel () {}
      })
    }
  }
}
</script>
